module.exports = __webpack_public_path__ + "media/images/okra-offers/app-screenshot-1-c00de81bf17e4e64f8e94458dd45068c.png";